import React from "react";
import { Container } from "./styles";
import { Link } from "gatsby";

const Title = ({ title, subTitle, navigateTo, large, onSubtitleClick }) => {
  return (
    <Container large={large}>
      <div className="header">
        <h1 className="title">{title}</h1>
        <Link to={navigateTo ? navigateTo : "#"} className="link">
          <p
            className="title-small highlight"
            onClick={onSubtitleClick}
            onKeyDown={onSubtitleClick}
          >
            {subTitle}
          </p>
        </Link>
      </div>
    </Container>
  );
};

export default Title;
